import { useAppDispatch } from 'store/hooks';
import { ReactFlowProvider } from '@xyflow/react';
import { Automations } from 'components/rules/automations/Automations';
import { MainLayout } from 'layouts/MainLayout';
import React from 'react';
import { getAllAudiences } from 'store/audiences/audiencesSlice';
import { getAllPerks } from 'store/perks/perksSlice';

export const AutomationsPage = () => {
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        dispatch(getAllPerks());
        dispatch(getAllAudiences());
    }, [dispatch]);
    return (
        <ReactFlowProvider>
            <MainLayout pageName="Automations" pageDescription="Explore the existing automations" noScroll>
                <Automations />
            </MainLayout>
        </ReactFlowProvider>
    );
};
